export default "__VITE_ASSET__rJlK0MbK__"